import axios from 'axios'
import { ElMessage } from 'element-plus'
import { BASE_URL, TIME_OUT } from '../../../service/config'

export const FINANCE_TOKEN_KEY = 'finance_token'
export const getFinanceToken = () => sessionStorage.getItem(FINANCE_TOKEN_KEY)
export const clearFinanceToken = () =>
  sessionStorage.removeItem(FINANCE_TOKEN_KEY)

const financeRequest = axios.create({ baseURL: BASE_URL, timeout: TIME_OUT })
financeRequest.interceptors.request.use((config) => {
  const token = getFinanceToken()
  if (token) config.headers.Authorization = `Bearer ${token}`
  config.headers['X-Request-Id'] = `${Date.now()}-${Math.random()
    .toString(16)
    .slice(2)}`
  return config
})
financeRequest.interceptors.response.use(
  (response) => {
    const payload = response.data
    if (
      payload &&
      payload.code !== undefined &&
      !/^2/.test(String(payload.code))
    ) {
      if (payload.code === 600) {
        clearFinanceToken()
        window.location.href = `/finance/login?redirect=${encodeURIComponent(
          window.location.pathname
        )}`
      }
      return Promise.reject(payload)
    }
    return payload && payload.code !== undefined ? payload.data : payload
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      clearFinanceToken()
      window.location.href = `/finance/login?redirect=${encodeURIComponent(
        window.location.pathname
      )}`
    }
    ElMessage.error(
      error.response?.data?.message || error.message || '财务请求失败'
    )
    return Promise.reject(error)
  }
)

export default financeRequest
